import TagManager from 'react-gtm-module'

import { CampaignPlatformTypeEnum, CampaignTypeEnum } from 'src/Types/campaigns'

import { EventNameEnum, EventTypeEnum } from '../tagManagerEnums'

export const campaignScheduleStartEvent = ({
  campaignType,
  genreList,
  campaignId,
  platformName,
  userId,
  campaignNumber,
  subscriptionPlan,
}: {
  campaignType: string
  genreList?: string
  campaignId: number | string
  platformName?: string
  userId?: number | string
  campaignNumber?: number
  subscriptionPlan?: string
}): void => {
  TagManager.dataLayer({
    dataLayer: {
      event: EventTypeEnum.CampaignScheduleStart,
      event_name: EventNameEnum.CampaignScheduleStart,
      'campaign-type': campaignType,
      'campaign-platform': platformName,
      'campaign-number':
        campaignType === CampaignTypeEnum.FIRST ? 1 : campaignNumber,
      'campaign-id': campaignId,
      userID: userId,
      ...(genreList ? { 'genre-list': genreList } : {}),
      ...(subscriptionPlan ? { subscription_plan: subscriptionPlan } : {}),
    },
  })
}

interface MsgLowReachReceivedArgs {
  type: string
  campaignNumber: number
  campaignId: string
  userId: number | string
  genreList?: string
}

export const msgLowReachReceived = ({
  type,
  campaignNumber,
  campaignId,
  userId,
  genreList,
}: MsgLowReachReceivedArgs): void => {
  TagManager.dataLayer({
    dataLayer: {
      event: EventTypeEnum.MsgLowReachReceived,
      event_name: EventNameEnum.MsgLowReachReceived,
      'campaign-type': type,
      'campaign-platform': CampaignPlatformTypeEnum.SPOTIFY,
      'campaign-number': type === CampaignTypeEnum.FIRST ? 1 : campaignNumber,
      'campaign-id': campaignId,
      ...(userId ? { userID: userId } : {}),
      'result-price': 0,
      'genre-list': genreList,
    },
  })
}
